"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFormSdk = createFormSdk;
const axios_1 = __importDefault(require("axios"));
const generated_1 = require("../generated");
const sdkHelper_1 = require("./sdkHelper");
// // Define a custom API exception to wrap failed responses.
// export class ApiError extends Error {
//     status: number;
//     responseData: ErrorResponse | null;
//     originalError: AxiosError;
//     constructor(
//         status: number,
//         responseData: ErrorResponse | null,
//         originalError: AxiosError
//     ) {
//         super(`API Error: ${status}`);
//         this.status = status;
//         this.responseData = responseData;
//         this.originalError = originalError;
//     }
// }
function createFormSdk(init, enhancer) {
    return _create(init, enhancer);
}
function _create(config, enhancer) {
    if (enhancer) {
        return enhancer(_create)(config);
    }
    const apiConfig = new generated_1.Configuration({
        basePath: config.baseUrl,
    });
    let client = config.axios;
    if (!client) {
        client = axios_1.default.create();
        // TODO fix openapi generator to properly deserialize dates
        client.interceptors.response.use((response) => {
            if (response.data && typeof response.data === 'object') {
                response.data = (0, sdkHelper_1.convertDates)(response.data);
            }
            return response;
        }
        // (error: AxiosError) => {
        //     // If there's a server response, wrap the error details.
        //     if (error.response) {
        //         throw new ApiError(
        //             error.response.status,
        //             error.response.data as ErrorResponse,
        //             error
        //         );
        //     }
        //     // For network errors or no response received, use status 408 (Request Timeout) or 500.
        //     throw new ApiError(
        //         error.status ?? (error.request ? 408 : 500),
        //         null,
        //         error
        //     );
        // }
        );
    }
    return {
        respondent: new generated_1.RespondentApi(apiConfig, config.baseUrl, client),
        admin: new generated_1.AdminApi(apiConfig, config.baseUrl, client),
    };
}
//# sourceMappingURL=sdkProvider.js.map